import React, { FunctionComponent } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'
import { useNotificationContext } from './NotificationProvider'

const NotificationContainer: FunctionComponent = () => {
  const { setNotification, notification } = useNotificationContext()

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setNotification({ message: undefined })
  }

  return (
    <Snackbar
      open={!!(notification && notification.message)}
      autoHideDuration={notification?.autoClose || 5000}
      onClose={handleClose}
    >
      <Alert severity={notification?.type || 'info'} onClose={handleClose}>
        {notification?.message}
      </Alert>
    </Snackbar>
  )
}

export default NotificationContainer
